import * as React from 'react';
import l10n from '../../util/l10n';
import TextField from 'material-ui/TextField';
import {ImageModuleBaseData} from './interfaces';
import {BaseViewProps, ImageViewProps, ImageWithTextViewProps} from './interfaces';

export default class ImageEditViewCaptions extends React.Component<BaseViewProps, {}> {
    render() {
        const style = this.getStyle();
        const data = this.props.payload;
        const props = this.props as BaseViewProps;
        return (
            <div style={style.root}>
                {this.hasTextProps(props) || (this.hasImageProps(props) && props.payload.supports.imageCaption) ?
                <TextField
                    style={style.textfield}
                    floatingLabelText={l10n('module.image.labels.caption')}
                    hintText={l10n('module.image.labels.captionHint')}
                    defaultValue={data.caption || null}
                    onChange={this.handleSubtitleChange}
                />
                : null}
                <TextField
                    style={style.textfield}
                    floatingLabelText={l10n('module.image.labels.alt')}
                    hintText={l10n('module.image.labels.altHint')}
                    defaultValue={data.imageAlt || null}
                    onChange={this.handleAltChange}
                />
            </div>
        );
    }

    private handleSubtitleChange = (e: React.FormEvent<{}>) => {
        const newData = {} as ImageModuleBaseData;
        newData.caption = (e.target as HTMLInputElement).value;
        this.props.onDataChange(newData);
    };

    private handleAltChange = (e: React.FormEvent<{}>) => {
        const newData = {} as ImageModuleBaseData;
        newData.imageAlt = (e.target as HTMLInputElement).value;
        this.props.onDataChange(newData);
    };

    private hasImageProps(props: BaseViewProps): props is ImageViewProps {
        return !props.module.hasText;
    }

    private hasTextProps(props: BaseViewProps): props is ImageWithTextViewProps {
        return props.module.hasText;
    }

    private getStyle() {
        return {
            root: {
                padding: "0 4px"
            },
            textfield: {
                marginRight: 24,
                marginTop: -14,
                width: 350
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/image/EditViewCaptions.tsx
 **/